import type { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'

import type { FormValues } from '../providers/SingleSeriesProvider/types'

type UpdateSingleSeriesPayload = Parameters<
  typeof MembershipsCreatorV2ApiClient.updateSingleSeries
>[1]

export const getUpdateSingleSeriesPayload = (values: FormValues): UpdateSingleSeriesPayload => {
  const getCoverImageResource = (): UpdateSingleSeriesPayload['coverImageResource'] => {
    if (!values.coverImage) {
      return {
        type: 'Remove',
      }
    }

    if (values.coverImageResourceId) {
      return {
        type: 'New',
        id: values.coverImageResourceId,
      }
    }

    return {
      type: 'Keep',
    }
  }

  const getThumbnailResource = (): UpdateSingleSeriesPayload['thumbnailResource'] => {
    if (!values.thumbnailImage) {
      return {
        type: 'Remove',
      }
    }

    if (values.thumbnailImageResourceId) {
      return {
        type: 'New',
        id: values.thumbnailImageResourceId,
      }
    }

    return {
      type: 'Keep',
    }
  }

  return {
    title: values.title,
    description: values.description || '',
    coverImageResource: getCoverImageResource(),
    thumbnailResource: getThumbnailResource(),
  }
}
